import { render, staticRenderFns } from "./lni-retaliation-documents.component.vue?vue&type=template&id=67c7cf44"
import script from "./lni-retaliation-documents.component.vue?vue&type=script&lang=js"
export * from "./lni-retaliation-documents.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports